import React from 'react';
import AtlasV2DropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DropdownMetricColumnChart';
import AtlasV2MetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricColumnChart';
import { OTHER_TRAFFIC_FILED_IDS } from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TotalTrafficTopEntity';
import { HIDE_GROUP_BY_LEVEL } from 'src/components/Layout/AtlasV2PageLayout';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 *
 * Organic Traffic TopEntity chart
 */
const AtlasV2OrganicTrafficByTopEntity = () => {
  const mainEntityType = useMainEntityType();

  return mainEntityType === 'product' ? (
    <AtlasV2MetricColumnChart
      fieldName="organicClicks"
      indexName="traffic"
      useAdvancedSearchDataArgs={{
        fields: [{ name: 'organicClicks' }],
        groupByField: 'searchTerm',
        addFieldsFromPrimaryResponse: true
      }}
      beaconChartWithLegendPropsBuilder={(props) => ({
        ...props,
        title: 'Organic Traffic by Keyword'
      })}
      preProcessData={(data) => {
        const otherTraffics = data.filter((datum) => OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        const remainingData = data.filter((datum) => !OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        return [...remainingData, ...otherTraffics];
      }}
    />
  ) : (
    <AtlasV2DropdownMetricColumnChart
      fieldName="organicClicks"
      indexName="traffic"
      dropdownOptions={[
        {
          id: 'searchTerm',
          label: 'Keyword'
        },
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        },

        {
          id: 'stacklineSku',
          label: 'Product'
        },
        {
          id: 'parentBrandId',
          label: 'Manufacturer'
        }
      ].filter(
        (option) =>
          !option.id.toLowerCase().startsWith(mainEntityType) &&
          HIDE_GROUP_BY_LEVEL?.[mainEntityType]?.[option.id] !== true
      )}
      useAdvancedSearchDataArgs={{
        requestBuilder: (builder, _isComparison, _fields) => {
          return builder;
        },
        addFieldsFromPrimaryResponse: true
      }}
      preProcessData={(data) => {
        const otherTraffics = data.filter((datum) => OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        const remainingData = data.filter((datum) => !OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        return [...remainingData, ...otherTraffics];
      }}
      titlePrefix="Organic Traffic by"
    />
  );
};

export default AtlasV2OrganicTrafficByTopEntity;
